'use strict';

angular.module('amexReconciliationApp')
    .component('userPreferences', {
        templateUrl: 'scripts/views/components/user-preferences.html',
        bindings: {
            currentUser: '<'
        },
        controller: function ($uibModal) {
            var self = this;

            self.openUserPreferencesModal = function () {
                $uibModal.open({
                    template: '<user-preferences-modal close-modal-callback="$close()"></user-preferences-modal>'
                });
            };

        }
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/userPreferences.js
// module id = 505
// module chunks = 0